import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import styled from "styled-components";

import { authApi, merchantApi } from "@api";
import { PATH_HOME } from "@configs";
import { IMemberShipTiers, IMemberTier } from "@interfaces";
import { deduplicate } from "src/Utils/requestDeduper";
import { ModuleMemberShipTier } from "@modules";
import { selectAuth, selectMerchant } from "@redux";
import { RenderMeta } from "@utils";
import { useEffect, useState } from "react";

interface IProps {
    avatar: string;
    fullName: string;
    memberTier: IMemberTier | undefined;
}

export const ComponentTIerDetail = (props: IProps) => {
    //page hook
    const { t } = useTranslation();
    //push route
    const history = useHistory();
    //page props
    const { avatar, fullName, memberTier } = props;
    //redux state
    const { memberShipTiers, themes } = useSelector(selectMerchant);
    const [pointValue, setPointValue] = useState<any>({
        totalPoint: 0,
        tierPoint: "-",
        tierMonth: "-",
        pointBalance: 0,
        currentTier: "",
        maintainPoint: 0,
        isBalance: false,
    });
    const [currentTier, setCurrentTier] = useState<any>();

    const themeMode = themes?.themeMode || "light";
    const { userInfo } = useSelector(selectAuth);
    //page variable
    const accumulativePoints = userInfo?.totalPoints || 0;
    const membershipTier = memberShipTiers?.find(
        (membershipTier) => membershipTier.pointThreshold > accumulativePoints
    );

    const present = Math.round(
        (+accumulativePoints / +(membershipTier?.pointThreshold || 1)) * 100
    );

    const membershipName =
        membershipTier?.membershipName ||
        (memberShipTiers &&
            memberShipTiers.length > 1 &&
            memberShipTiers[memberShipTiers?.length - 1].membershipName);

    const handleGoHome = () => {
        history.push(PATH_HOME);
    };
    useEffect(() => {
        getConfig();
    }, []);

    const getConfig = async () => {
        let userRes = await deduplicate("merchant-config", () => merchantApi.getMerchantConfig());
        let merRes = await authApi.getInfo();
        let tierList = userRes?.data?.merchant?.membershipTiers;
        let thisTier: IMemberShipTiers = tierList.find(
            (x: any) => x.membershipName === merRes?.data?.contact?.memberTierName
        );
        setCurrentTier(thisTier);
        let attPer = userRes?.data?.merchant?.superAdminTier?.isPointBalance
            ? merRes?.data?.percentToNextTierPointBalance
            : merRes?.data?.percentToAttain;
        let mainPer = merRes?.data?.percentToMaintain;
        let item = {
            isBalance: userRes?.data?.merchant?.superAdminTier?.isPointBalance,
            allPointEarn: merRes?.data?.allPointEarn,
            pointEarnToAttain: merRes?.data?.pointEarnToAttain,
            nextTierPoint: merRes?.data?.pointEarnToAttain - merRes?.data?.allPointEarn,
            isLast: tierList[tierList?.length - 1]?.membershipName === thisTier?.membershipName,
            isFirst: tierList[0]?.membershipName === thisTier?.membershipName,
            tierMonth: merRes?.data?.monthToAttain,
            totalPoints: merRes?.data?.totalPoints,
            BalancePointToNextTier: merRes?.data?.BalancePointToNextTier,
            pointEarnRemainToMaintain: merRes?.data?.pointEarnRemainToMaintain,
            maintainDate: merRes.data.maintainDate,

            attentPercent: attPer,
            maintainPercent: mainPer,
        };
        setPointValue(item);
    };

    return (
        <>
            <RenderMeta title={t("meta.membership_tier")} />
            <StyledTierDetail color={currentTier?.color || "#000"}>
                <div className="content">
                    <StyledCardTier mainColor={currentTier?.color || "white"}>
                        <div className="current-tier">Current tier</div>
                        <div className="detail-card-tier">
                            <div className="topic-tier-card">
                                Welcome {currentTier?.membershipName}
                                {/* {pointValue?.isBalance ? " balance" : " earn"} */}
                            </div>
                            <div className="name-tier-card">{fullName}</div>

                            {!pointValue?.isBalance &&
                                !pointValue?.lastTier &&
                                pointValue?.nextTierPoint > 0 && (
                                    <div className="pointto-tier-card">
                                        {pointValue?.nextTierPoint} point to next tier
                                    </div>
                                )}
                            <div className="point-balance">
                                Point balance : <span>{pointValue?.totalPoints}</span>
                            </div>
                        </div>
                        <div className="point-tier">
                            <div className="square">
                                <CircularProgressbar
                                    value={pointValue?.attentPercent}
                                    strokeWidth={10}
                                    styles={buildStyles({
                                        pathColor: currentTier?.color,
                                    })}
                                />
                                <div className="text">
                                    <div className="point-earn">
                                        {!pointValue?.isBalance && (
                                            <div className="text-earn">Points earned :</div>
                                        )}

                                        <div className="point">
                                            {pointValue?.isBalance
                                                ? pointValue?.totalPoints
                                                : pointValue?.allPointEarn}
                                            /
                                            {pointValue?.isBalance
                                                ? pointValue?.BalancePointToNextTier
                                                : pointValue?.pointEarnToAttain}
                                        </div>
                                        {!pointValue?.isBalance && (
                                            <div className="last-month-tier">
                                                Last {pointValue?.tierMonth} months
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </StyledCardTier>
                    <ModuleMemberShipTier
                        maintainPoint={pointValue?.pointEarnRemainToMaintain}
                        firstTier={pointValue?.isFirst}
                        percent={pointValue?.maintainPercent}
                        date={pointValue?.maintainDate ? pointValue?.maintainDate : ""}
                        tierColor={currentTier?.color || "white"}
                        tierIcon={currentTier?.icon || "star"}
                        isBalance={pointValue?.isBalance || false}
                    />
                </div>
            </StyledTierDetail>
        </>
    );
};

const StyledCardTier = styled.div<{ mainColor: string }>`
    min-height: 195px;
    background-color:${(p) => p.mainColor};
    border-top-right-radius: 16px;
    border-top-left-radius: 16px;
    width: calc(100% - 30px);
    margin: 0 auto;
    position: relative;
    overflow: hidden;
    margin-top: 60px;
    &:after {
        content: "";
        width: 300px;
        height: 300px;
        border-radius: 100%;
        position: absolute;
        top: -170px;
        right: -170px;
        background-color: rgba(255, 255, 255, 0.2);
    }
    &:before {
        content: "";
        width: 360px;
        height: 170px;
        position: absolute;
        top: 0;
        right: 0;
        background: linear-gradient(
            90deg,
            rgba(255, 255, 255, 0) 0%,
            rgba(255, 255, 255, 0.3) 100%
        );
    }
    .current-tier {
        position: absolute;
        top: 0;
        left: 0;
        color: #9b9b9b;
        background-color: #fff;
        width: 85px;
        text-align: center;
        padding: 4px 12px 4px 12px;
        border-radius: 0px 0px 11px 0px;
        font-size: 11px;
    }
    .point-tier {
        position: absolute;
        right: 20px;
        top: 50%;
        transform: translateY(-50%);
    }
    .detail-card-tier {
        position: absolute;
        top: 32px;
        left: 16px;
        max-width: 175px;
        .topic-tier-card {
            color: #fff;
            font-size: 18px;
            line-height: 24px;
            font-weight: 500;
            margin-bottom: 5px;
        }
        .name-tier-card {
            color: #fff;
            font-style: italic;
            font-size: 12px;
            line-height: 16px;
            margin-bottom: 30px;
        }
        .pointto-tier-card {
            padding-left: 17px;
            color: rgba(255, 255, 255, 0.6);
            font-size: 11px;
            line-height: 16px;
            background-image: url(../../images/ic-star-card.svg);
            background-size: 12px;
            background-repeat: no-repeat;
            background-position: center left;
            margin-bottom: 15px;
        }
        .point-balance {
            font-size: 11px;
            line-height: 14px;
            color: #fff;
        }
    }
`;

const StyledTierDetail = styled.div<{ color: string }>`
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    .avatar {
        border-radius: 0 0 8px 8px;
        /* box-shadow: rgb(211 211 211) 2px 3px 8px 0px; */
        /* margin-bottom: 8px; */
        padding: 32px 0;
        background-color: ${(p) => p.theme.colors.home_bg};
        /* background: ${(p) => p.theme.colors.card}; */
        display: flex;
        align-items: center;
        @media (max-width: ${(p) => p.theme.breakPoints.breakMobile}) {
            padding: 20px 0;
        }
        .image {
            margin: 0 16px;
            img {
                border-radius: 50%;
                width: 94px;
                height: 94px;
                object-fit: cover;
                @media (max-width: ${(p) => p.theme.breakPoints.breakMobile}) {
                    width: 76px;
                    height: 76px;
                }
            }
        }
        .info {
            .rank {
                align-items: center;
                justify-content: center;
                display: flex;
                min-width: 50px;
                border-radius: 16px;
                padding: 4px 6px;
                font-style: normal;
                font-weight: 500;
                font-size: 8px;
                background-color: ${(p) => p.color};
                width: fit-content;
                color: ${(p) => p.theme.colors.color};
                img {
                    width: 12px;
                    height: 12px;
                    object-fit: cover;
                    margin-right: 4px;
                }
                span {
                    display: inline-block;
                    margin-right: 4px;
                    font-weight: 500;
                    font-size: 8px;
                }
            }
        }
    }
    .content {
        flex: 1;
        // background: ${(p) => p.theme.colors.home_bg};
        background-color: #e8e8e8;
        background-image: url(../../images/bg-tier.svg);
        background-position: top right;
        background-size: contain;
        background-repeat: no-repeat;
        .square {
            position: relative;
            height: fit-content;
            text-align: center;
            @media (max-width: ${(p) => p.theme.breakPoints.breakMobile}) {
                padding: 42px 0;
            }
            img {
                width: 100%;
            }
            .text {
                position: absolute;
                top: 0;
                left: 0;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
                width: 100%;
                height: 100%;
                .point {
                    font-style: normal;
                    margin: 6px 0;
                    font-size: 12px;
                    color: #fff;
                }
                .points {
                    margin-top: -4px;
                    font-size: 12px;
                    color: #fff !important;
                }
                .to_level {
                    font-style: normal;
                    font-size: 12px;
                    color: #fff;
                }
                .point-balance {
                    .text-tier {
                        color: rgba(255, 255, 255, 0.74);
                        font-size: 10px;
                    }
                }
                .point-earn {
                    .point {
                        margin-top: 0;
                    }
                    .text-earn {
                        font-size: 10px;
                        line-height: 10px;
                        color: rgba(255, 255, 255, 0.74);
                    }
                    .last-month-tier {
                        font-size: 10px;
                        color: rgba(255, 255, 255, 0.74);
                    }
                }
            }
        }
    }
    .CircularProgressbar {
        width: 140px;
    }
    .CircularProgressbar-path {
        box-shadow: rgba(255, 255, 255, 0.35) 0px 5px 15px !important;
        stroke: rgba(255, 255, 255, 1) !important;
        stroke-width: 8;
    }
    .CircularProgressbar-trail {
        stroke: rgba(255, 255, 255, 0.5) !important;
        stroke-width: 8;
    }
`;

const StyledHomeBackLayout = styled.div`
    /* width: calc(100% - 30px); */
    width: 100%;
    margin: 0 auto;
    padding-left: 20px;
    background-color: transparent;
    background-color: ${(p) => p.theme.colors.home_bg};
`;
